import { createContext, useContext } from "react"

export const ModelContext = createContext({
  isModelOpen: false,
  toggleIsModel: () => {},
})

export const useModel = () => useContext(ModelContext)
export const ModelProvider = ModelContext.Provider
